module.exports = __webpack_public_path__ + "static/9-e6b233326b02033c0ac3b55899f224e7.jpg";